module.exports = {
      id: "document-usage",
      viewBox: "0 0 29 40",
      url: __webpack_public_path__ + "assets/img/sprite-598bc0.svg#document-usage",
      toString: function () {
        return this.url;
      }
    }